const TOOLTIP_POSITION = {
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top'
};

export { TOOLTIP_POSITION };
